module.exports = __webpack_public_path__ + "media/confirm_style_1_echo_005.2711a351.mp3";